import React from 'react';
import { Link } from 'react-router-dom';
import { ListOrdered } from 'lucide-react';
import { ParkingQueueEntry, QUEUE_CLOSE_REASON_LABELS } from '../../types/parkingQueue';
import '../Leases/Leases.css';

interface TenantQueueEntryCardProps {
    entry: ParkingQueueEntry;
}

const areasLabel = (count: number): string => (count === 1 ? '1 önskat område' : `${count} önskade områden`);

/**
 * Compact read-only summary of one queue entry on the tenant page (spec FR17).
 * Area names are not loaded here, so wishes are shown as a count; the full
 * entry is one click away in the queue.
 */
const TenantQueueEntryCard: React.FC<TenantQueueEntryCardProps> = ({ entry }) => {
    const isActive = entry.status === 'active';
    const areaCount = Object.keys(entry.wantedAreas).length;
    const statusLabel = isActive
        ? 'I kö'
        : `Avslutad${entry.closeReason ? ` · ${QUEUE_CLOSE_REASON_LABELS[entry.closeReason]}` : ''}`;

    return (
        <div className={`tenant-queue-card${isActive ? '' : ' tenant-queue-card--closed'}`}>
            <div className="tenant-queue-card-header">
                {/* The lease cards' status pill (Leases.css), so the tenant page has one status look */}
                <span className={`lease-status lease-status--${isActive ? 'active' : 'ended'}`}>{statusLabel}</span>
                <Link to={`/parking-queue?entry=${entry.key}`} className="tenant-queue-card-link">
                    <ListOrdered size={14} className="me-1" />Visa i kön
                </Link>
            </div>
            <div className="tenant-queue-card-facts text-muted">
                <span>Ködatum {entry.queueDate}</span>
                <span>{areasLabel(areaCount)}</span>
            </div>
        </div>
    );
};

export default TenantQueueEntryCard;
